import { applyMiddleware, combineReducers, legacy_createStore as createStore, compose } from "redux";
import catologItemsReducer from './catologItems-reducer';
import filterCatalogReducer from './filtercatalog-reduser';
import filterSortReducer from './filtersort-reduser';
import thunkMiddleware from 'redux-thunk';
import itemReducer from './Item-reducer';
import indexPageReducer from './index-reduser';
import userPageReducer from './user-reduser';

let reducers =combineReducers({
    catologItems:catologItemsReducer,
    filterItems:filterCatalogReducer,
    filterSort:filterSortReducer,
    item:itemReducer,
    indexPage:indexPageReducer,
    userPage:userPageReducer,
});


//let store = createStore(reducers,applyMiddleware(thunkMiddleware));
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ||  compose;
const store = createStore(reducers, composeEnhancers(
    applyMiddleware(thunkMiddleware)
  ));

window.store=store;

export default store;